export default __webpack_public_path__ + "static/media/js-img.d93609ec.jpg";